import React, { useRef } from "react";
import './contact.css'
import { MdOutlineEmail } from 'react-icons/md'
import { BsLinkedin, BsWhatsapp } from 'react-icons/bs'
import emailjs from 'emailjs-com';

const Contact = () => {
    const form = useRef();

    const sendEmail = (e) => {
        e.preventDefault();
        emailjs.sendForm(
            process.env.REACT_APP_EMAILSERVICEID,
            process.env.REACT_APP_EMAILTEMPLATEID,
            form.current,
            process.env.REACT_APP_EMAILPUBLICKEY
        ).then(
            (result) => { console.log(result.text); },
            (error)  => { console.log(error.text); }
        );
        e.target.reset();
    };

    return (
        <section id="contact">
            <h5>$ ./contact.sh</h5>
            <h2>Contact Me</h2>
            <div className="container contact__container">
                <div className="contact__options">
                    <article className="contact__option">
                        <MdOutlineEmail className="contact__option-icon"/>
                        <h4>Email</h4>
                        <h5>rsumit123@gmail.com</h5>
                        <a href="mailto:rsumit123@gmail.com" target="_blank" rel="noreferrer">Send an Email</a>
                    </article>
                    <article className="contact__option">
                        <BsLinkedin className="contact__option-icon"/>
                        <h4>LinkedIn</h4>
                        <h5>rsumit123</h5>
                        <a href="https://linkedin.com/in/rsumit123" target="_blank" rel="noreferrer">Send a Message</a>
                    </article>
                    <article className="contact__option">
                        <BsWhatsapp className="contact__option-icon"/>
                        <h4>Whatsapp</h4>
                        <h5>+917077856293</h5>
                        <a href="https://api.whatsapp.com/send?phone=+917077856293" target="_blank" rel="noreferrer">Send a message</a>
                    </article>
                </div>

                <div className="contact__form-window term-window">
                    <div className="term-titlebar">
                        <span className="term-dot red"></span>
                        <span className="term-dot yellow"></span>
                        <span className="term-dot green"></span>
                        <span className="term-path">~/contact.sh</span>
                    </div>
                    <form ref={form} onSubmit={sendEmail} className="contact__form">
                        <label className="contact__label mono" htmlFor="contact-name"><span className="txt-green">$</span> name</label>
                        <input id="contact-name" type="text" name="name" placeholder="Your full name" required/>

                        <label className="contact__label mono" htmlFor="contact-email"><span className="txt-green">$</span> email</label>
                        <input id="contact-email" type="email" name="email" placeholder="you@domain.com" required/>

                        <label className="contact__label mono" htmlFor="contact-message"><span className="txt-green">$</span> message</label>
                        <textarea id="contact-message" name="message" rows="6" placeholder="What's on your mind?" required></textarea>

                        <button type="submit" className="btn btn-primary mono">$ send</button>
                    </form>
                </div>
            </div>
        </section>
    )
}

export default Contact
